import * as e from "react";
import { forwardRef as r } from "react";
const f = r(function(o, l) {
  return /* @__PURE__ */ e.createElement(
    "svg",
    {
      fill: "none",
      ref: l,
      viewBox: "0 0 24 24",
      xmlns: "http://www.w3.org/2000/svg",
      ...o
    },
    /* @__PURE__ */ e.createElement(
      "path",
      {
        clipRule: "evenodd",
        d: "M17.2305 8.11525C17.2305 10.9277 14.9453 13.2305 12.1152 13.2305C9.28517 13.2305 7 10.9277 7 8.11525C7 5.28517 9.28517 3 12.1152 3C14.9453 3 17.2305 5.28517 17.2305 8.11525ZM10.1465 14.1973L11.2188 17.2383V21H13.0118V17.2383L14.1016 14.1973H10.1465Z",
        fill: "currentColor",
        fillRule: "evenodd"
      }
    )
  );
});
export {
  f as Golf
};
